/**
 * Backwards-compat re-export. 17 callsites cũ import từ '.../fb-login' —
 * giữ barrel để khỏi touch từng file. Tên `LoginDialog` giữ nguyên signature.
 *
 * New code SHOULD import `NewLoginDialog` từ `@/components/auth/new-login-dialog`.
 */
export { NewLoginDialog as LoginDialog } from '@/components/auth/new-login-dialog';
